<div class="suburb-pending">
  <ng-container *ngIf="open === null; else onePlace">
    <div class="text-sm text-600 mb-2">Places that aren't Conductor providers go on the website only after a person approves them. Some were asked for by the team; the AI suggests others for suburb pages, with its reason.</div>
    <div class="flex flex-wrap gap-2 mb-2">
      <button type="button" class="chip" [class.on]="source === ''" (click)="source = ''">All <span class="n">{{ countOf('') }}</span></button>
      <button type="button" class="chip pending-ai" [class.on]="source === 'ai'" (click)="source = 'ai'">AI suggested <span class="n">{{ countOf('ai') }}</span></button>
      <button type="button" class="chip" [class.on]="source === 'user'" (click)="source = 'user'">Asked by the team <span class="n">{{ countOf('user') }}</span></button>
    </div>
    <div *ngIf="!loading && rows.length < total" class="text-600 text-sm mb-2 pending-capped">Showing {{ rows.length | number }} of {{ total | number }}: the team's requests first, then the newest. The rest load when you come back to this list.</div>
    <div *ngIf="loading" class="text-600">Loading…</div>
    <div *ngIf="error" class="err">{{ error }}</div>
    <div *ngIf="message" class="ok-msg mb-2">{{ message }}</div>
    <div *ngIf="!loading && !error && !visible.length" class="text-600 text-sm">Nothing is waiting for review.</div>
    <ul class="plain pending-list">
      <li *ngFor="let r of visible; trackBy: trackRow" class="pending-row" (click)="open = r.locationId">
        <div class="flex justify-content-between align-items-start gap-2">
          <div class="min-w-0">
            <div class="font-medium truncate">{{ r.name || 'Place ' + r.locationId }}</div>
            <div class="text-600 text-xs">{{ r.kind ? kindLabel(r.kind) : '' }}{{ r.suburb ? ' · ' + r.suburb : '' }}</div>
          </div>
          <span *ngIf="!readOnly" class="flex gap-1 flex-shrink-0">
            <button pButton type="button" icon="pi pi-check" class="p-button-rounded p-button-success p-button-sm pending-approve" pTooltip="Approve: on the website" tooltipPosition="left"
                    [disabled]="busy" (click)="decide(r, 'approve', $event)" aria-label="Approve"></button>
            <button pButton type="button" icon="pi pi-times" class="p-button-rounded p-button-danger p-button-sm pending-reject" pTooltip="Reject: stays off the website" tooltipPosition="left"
                    [disabled]="busy" (click)="decide(r, 'reject', $event)" aria-label="Reject"></button>
          </span>
        </div>
        <div class="mt-1 text-xs">
          <ng-container *ngIf="r.requestSource === 'ai'; else person">
            <span class="ai-tag">AI suggested</span>
            <span class="text-500"> {{ r.requestedAt | date: 'd MMM, h:mm a' }}{{ r.aiModel ? ' · ' + r.aiModel : '' }}</span>
          </ng-container>
          <ng-template #person><span class="text-600">Asked by {{ who(r) }} · {{ r.requestedAt | date: 'd MMM, h:mm a' }}</span></ng-template>
        </div>
        <div *ngIf="r.requestSource === 'ai' && r.requestNote" class="ai-note">{{ r.requestNote }}</div>
      </li>
    </ul>
  </ng-container>

  <ng-template #onePlace>
    <a class="text-sm cursor-pointer pending-back" (click)="open = null"><i class="pi pi-arrow-left text-xs"></i> Waiting for review</a>
    <app-suburb-place class="block mt-2" [locationId]="open!" [readOnly]="readOnly" (changed)="onChanged($event)"></app-suburb-place>
  </ng-template>
</div>
